import * as React from "react"

export default class NotFoundView extends React.Component {
  public render () {
    return (
      <div>Page Not Found</div>
    )
  }
}